import { WHITESPACE } from './_consts';
/**
 * Returns true if the string is undefined, null or whitespace
 * @param str
 */
export default function isNullOrWhitespace(str) {
    const regex = new RegExp(`^[${WHITESPACE}]+$`, 'g');
    return str === undefined || str === null || regex.test(str);
}
